import React from 'react';
import ServiceLandingPage from './ServiceLandingPage';
import { useDocumentSEO } from '../utils/useDocumentSEO';

/**
 * /criacao-de-sites
 * NATIONAL SEO target: business websites for companies across Brazil.
 */
const CriacaoDeSitesPage = () => {
  useDocumentSEO({
    title:
      'Criação de Sites Profissionais para Empresas | Sites Otimizados para Google',
    description:
      'Criação de sites profissionais para empresas em todo o Brasil. Design exclusivo, otimização SEO, integração com WhatsApp e Google Analytics. Atendemos institucionais, lojas virtuais e portais corporativos.',
    canonical: 'https://www.agenciacoutin.com.br/criacao-de-sites',
    ogImage:
      'https://images.unsplash.com/photo-1487014679447-9f8336841d58?q=85&w=1200&auto=format&fit=crop',
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      serviceType: 'Criação de Sites Profissionais',
      provider: {
        '@type': 'Organization',
        name: 'Coutin Agência',
        url: 'https://www.agenciacoutin.com.br',
        telephone: '+55-45-98806-8508',
      },
      areaServed: { '@type': 'Country', name: 'Brasil' },
      description:
        'Desenvolvimento de sites institucionais, lojas virtuais, portais corporativos e plataformas customizadas com foco em SEO e conversão.',
      url: 'https://www.agenciacoutin.com.br/criacao-de-sites',
    },
  });

  return (
    <ServiceLandingPage
      gaSource="page-criacao-sites"
      showLocalProof={false}
      overline="Criação de Sites Profissionais"
      h1="Criação de sites profissionais que vendem para empresas no Brasil."
      highlightWord="que vendem"
      subtitle="Desenvolvemos sites institucionais, lojas virtuais, portais corporativos e plataformas customizadas pensados para gerar autoridade, ranquear no Google e converter visitantes em clientes. Atendimento em todo o Brasil."
      whatsappMessage="Olá! Vim pela página de criação de sites e gostaria de um orçamento. Tipo de projeto (institucional, e-commerce, portal, customizado):"
      heroImage="https://images.unsplash.com/photo-1487014679447-9f8336841d58?q=85&w=1200&auto=format&fit=crop"
      benefits={[
        { value: '100%', label: 'Mobile-First' },
        { value: 'SEO', label: 'Otimizado Google' },
        { value: '1 Ano', label: 'Hospedagem Inclusa' },
        { value: '30 Dias', label: 'Garantia de Ajustes' },
      ]}
      intro={[
        'Hoje, ter um site bonito não é suficiente. Sua empresa precisa de uma plataforma rápida, otimizada para o Google, integrada ao WhatsApp e desenhada com arquitetura de conversão. É exatamente isso que a Coutin Agência entrega para empresas em todo o Brasil há mais de 10 anos.',
        'Não somos uma agência genérica de sites. Cada projeto começa com um briefing estratégico para entender o seu público, sua concorrência e as palavras-chave que você precisa dominar no Google. Só então iniciamos o design — sempre exclusivo, nunca template pronto.',
        'Trabalhamos com tecnologias modernas (React, Next.js, WordPress headless quando faz sentido), técnicas avançadas de SEO técnico e integrações nativas com WhatsApp, Google Analytics, Google Tag Manager, Meta Pixel e ferramentas de e-mail marketing.',
      ]}
      blocks={[
        {
          h2: 'Tipos de site que desenvolvemos',
          subtitle:
            'Cada projeto é único — orçamento personalizado conforme o porte e a complexidade. Trabalhamos com empresas de Foz do Iguaçu, Cascavel, Curitiba, São Paulo, Rio de Janeiro e demais cidades do Brasil.',
          list: [
            'Sites institucionais para empresas e profissionais',
            'Landing pages de alta conversão para campanhas',
            'Lojas virtuais (e-commerce) integradas',
            'Portais corporativos com área restrita',
            'Plataformas customizadas com painel administrativo',
            'Sites para escritórios de advocacia, clínicas e consultórios',
            'Sites para construtoras e imobiliárias',
            'Migração e redesign de sites antigos',
          ],
        },
        {
          h2: 'O que está incluso em todo projeto',
          list: [
            'Design exclusivo, criado especificamente para o seu negócio',
            'Otimização SEO técnico (Core Web Vitals, semântica, schema.org)',
            'Versão mobile impecável (Mobile-First)',
            'Integração com WhatsApp, Google Analytics e Meta Pixel',
            'Painel de gestão de conteúdo (CMS) intuitivo',
            'Hospedagem + Domínio + Certificado SSL inclusos no primeiro ano',
            'Backup automático diário',
            '30 dias de ajustes finos após o lançamento',
          ],
        },
        {
          h2: 'Atendemos empresas em todo o Brasil',
          paragraphs: [
            'Nossa sede fica em Foz do Iguaçu (PR), mas atendemos empresas em todas as regiões do Brasil. Toda a comunicação é feita por reunião online (Google Meet ou Zoom), WhatsApp e e-mail. Para projetos especiais, oferecemos visitas presenciais.',
            'Já desenvolvemos sites para clientes em Foz do Iguaçu, Cascavel, Curitiba, São Paulo, Rio de Janeiro, Belo Horizonte, Brasília, Florianópolis, Porto Alegre, Salvador e várias outras cidades. O que importa não é distância — é a clareza do briefing e a qualidade da entrega.',
          ],
        },
        {
          h2: 'Por que escolher a Coutin para criar seu site',
          paragraphs: [
            'Diferente de freelancers que somem depois do projeto ou agências enormes que tratam você como mais um número, a Coutin oferece o melhor dos dois mundos: estrutura profissional + atenção personalizada. Cada cliente tem um responsável direto pelo projeto, que acompanha do briefing à entrega.',
            'Nossa nota máxima no Google (5,0 estrelas) é fruto de mais de uma década de trabalho consistente. Quando você contrata a Coutin, você contrata uma equipe que vai entregar prazo respeitado, qualidade técnica, design exclusivo e atendimento humano.',
          ],
        },
      ]}
    />
  );
};

export default CriacaoDeSitesPage;
